var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CImage',{attrs:{"url":_vm.properties.image,"alt":_vm.properties.alt ? _vm.properties.alt : 'image not found'}})}
var staticRenderFns = []

export { render, staticRenderFns }